import * as R from "ramda";
import lens from "../lenses/platform-reporting";

export default {
  root: R.view(lens),
  dashboards: R.view(lens.dashboards),
  selectedDashboardId: R.view(lens.selectedDashboardId),
  embed: R.view(lens.embed),
  error: R.view(lens.error),
  loadingDashboards: R.view(lens.loadingDashboards),
  loadingEmbed: R.view(lens.loadingEmbed),
};
